<template>
  <StreamPlatformForm
    :platform-key="'twitch'"
    :close-modal="closeModal"
    :cast-details="castDetails"
    :step-three-props="stepThreeProps"
    :handle-edit-cast="handleEditCast"
  />
</template>

<script>
import StreamPlatformForm from './StreamPlatformForm.vue';

export default {
  name: 'TwitchStreamModal',
  props: ['closeModal', 'castDetails', 'stepThreeProps', 'handleEditCast'],
  components: { StreamPlatformForm },
};
</script>
